import { render, staticRenderFns } from "./OrganizationProfileDrawer.vue?vue&type=template&id=b82bf7a2&scoped=true"
import script from "./OrganizationProfileDrawer.vue?vue&type=script&lang=js"
export * from "./OrganizationProfileDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationProfileDrawer.vue?vue&type=style&index=0&id=b82bf7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82bf7a2",
  null
  
)

export default component.exports